import classnames from 'classnames/bind';
import styles from './index.module.scss';
import StyledComponentsRegistry from '@/components/styled-components-registry';
import { RtFrame } from '@dpa/react-frame-intro';

const BLOCK_NAME = 'App-layout';
const cn = classnames.bind(styles);

type TProps = {
  children: React.ReactNode;
  isSideMode?: boolean;
};

export const AppLayout = ({ children, isSideMode }: TProps) => {
  return (
    <div
      className={cn(BLOCK_NAME, {
        [`${BLOCK_NAME}--side-mode`]: isSideMode,
      })}
    >
      <RtFrame
        modifier="base"
        scheme="ritm"
        achromatic="non-inverted"
        primitive="normal"
        theme="light"
        use="secondary"
        sizeScheme="ritm"
        typographyScheme="primary"
        typescale="base"
        breakpointScheme="ritm"
        operatorScheme="ritm"
      >
        <StyledComponentsRegistry>
          <div
            className={cn(`${BLOCK_NAME}__components`, {
              [`${BLOCK_NAME}__components--side-mode`]: isSideMode,
            })}
          >
            {children}
          </div>
        </StyledComponentsRegistry>
      </RtFrame>
    </div>
  );
};
